import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FiRotateCcw } from 'react-icons/fi';
import type { DashboardAlert } from '../types/dashboard';
import { alertPath } from '../utils/dashboardPaths';

interface Props {
  alert: DashboardAlert;
  scope: string;
  scopeId: number;
}

export function reopenRequestsMessage(alert: DashboardAlert): string {
  const count = alert.count ?? 1;
  return `${count} reopen request${count === 1 ? '' : 's'} waiting`;
}

/** Nation: compact notice for reporting periods someone asked to reopen. */
const ReopenRequestsNotice: React.FC<Props> = ({ alert, scope, scopeId }) => {
  const navigate = useNavigate();
  const path = alertPath(alert.type, scope, scopeId);

  return (
    <div className="dashboard-invite-notice" role="status">
      <FiRotateCcw size={18} className="flex-shrink-0" aria-hidden />
      <span className="dashboard-invite-notice__text min-w-0">{reopenRequestsMessage(alert)}</span>
      {path ? (
        <Button
          size="sm"
          variant="outline-primary"
          className="flex-shrink-0 text-nowrap"
          onClick={() => navigate(path)}
        >
          Review
        </Button>
      ) : null}
    </div>
  );
};

export default ReopenRequestsNotice;
